module.exports = __webpack_public_path__ + "img/BIT_white25.8dc1c832.jpg";